import { attachAsyncAppsFromManifest, initFederation, loadManifest } from '@gohighlevel/ghl-module-federation-plugin'

const remoteConfigEnv = {
  development: {
    calendarSettingsApp: 'http://localhost:3005/remoteEntry.js?nocache=true',
  },
  staging: {
    calendarSettingsApp: 'https://staging.appcdn.leadconnectorhq.com/automation/calendar-settings/remoteEntry.js?nocache=true',
  },
  interop: {
    calendarSettingsApp: 'https://interop.appcdn.leadconnectorhq.com/automation/calendar-settings/remoteEntry.js?nocache=true',
  },
  beta: {
    calendarSettingsApp: 'https://beta.appcdn.leadconnectorhq.com/automation/calendar-settings/remoteEntry.js?nocache=true',
  },
  production: {
    calendarSettingsApp: 'https://appcdn.leadconnectorhq.com/automation/calendar-settings/remoteEntry.js?nocache=true',
  },
}

let config = remoteConfigEnv[process.env.NODE_ENV]

export const initRemoteApps = async () => {
  const env = process.env.NODE_ENV

  const buildRemotes = config =>
    Object.entries(config).map(([key, entry]) => ({
      name: key,
      alias: key,
      entry,
    }))

  const initWithRemotes = config => {
    const remoteApps = buildRemotes(config)
    initFederation({
      name: 'settings-remote-apps',
      remotes: remoteApps,
    })
  }

  if (env !== 'development' && env !== 'staging') {
    await loadManifest(env)
    config = attachAsyncAppsFromManifest(config, env)
    initWithRemotes(config)
    return
  }
  initWithRemotes(config)
}
